<template>
  <div class="calendar-legend">
    <div class="verticallyCenter mt12 mb16 legend-position-set">
      <span class="mr16">位置</span>
      <el-tabs class="flex1" v-model="legendPosition" @tab-click="changeLegendPosition">
        <el-tab-pane label="左下" name="0"></el-tab-pane>
        <el-tab-pane label="右下" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <cx-check-box :value.sync="showTodayLegend" class="mb16">显示今日</cx-check-box>
    <div v-show="showTodayLegend" class="legend-set-box mt16 mb16">
      <div class="content">
        <div class="content-item mb16 verticallyCenter">
          <span class="fs14 mr16">文字内容</span>
          <el-input class="flex1" v-model="todayLegendVal" placeholder="请输入内容"></el-input>
        </div>
        <div class="content-item mb16">
          <p class="font14 mb16 mt16">文字样式</p>
          <text-setting-update
            :fontColor.sync="todayLegendColor"
            :fontFamily.sync="todayLegendFontFamily"
            :fontSize.sync="todayLegendFontSize"
            :fontWeight.sync="todayLegendFontWeight"
          />
        </div>
        <p class="font14 mb16 mt16">图标样式</p>
        <div class="content-item mb16 legend-today-bg-set verticallyCenter">
          <span class="font14 mr12 label">样式</span>
          <el-tabs class="flex1" v-model="activeTodayLegendStyle" @tab-click="changeTodayLegendStyleFn">
            <el-tab-pane label="实心" name="solid"></el-tab-pane>
            <el-tab-pane label="空心" name="hollow"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="content-item mb16 verticallyCenter legend-shape-set">
          <span class="mr16">形状</span>
          <el-tabs class="flex1" v-model="todayLegendShapeType" @tab-click="changeTodayLegendShapeType">
            <el-tab-pane name="round"
              ><el-tooltip slot="label" class="item" effect="dark" content="圆形" placement="top-end" :open-delay="1000"
                ><i class="icon-portal-round"></i></el-tooltip
            ></el-tab-pane>
            <el-tab-pane name="rectangle"
              ><el-tooltip slot="label" class="item" effect="dark" content="矩形" placement="top-end" :open-delay="1000"
                ><i class="icon-portal-rectangle"></i></el-tooltip
            ></el-tab-pane>
            <el-tab-pane name="radius"
              ><el-tooltip
                slot="label"
                class="item"
                effect="dark"
                content="圆角矩形"
                placement="top-end"
                :open-delay="1000"
                ><i class="icon-portal-rounded-rectangle"></i></el-tooltip
            ></el-tab-pane>
          </el-tabs>
        </div>
        <slider-and-input
          class="mb16 width40"
          :value.sync="todayLegendBorderRadius"
          title="圆角"
          :sliderMax="99"
          :sliderMin="1"
          suffix="px"
        />
        <div class="verticallyCenter mb16">
          <div class="mr16" style="width: 40px">尺寸</div>
          <div class="flex1 verticallyCenter cx_style">
            <single-input
              class="mr12"
              :value.sync="todayLegendWidth"
              inputSuffixs="宽"
            />
            <single-input
              :value.sync="todayLegendHeight"
              inputSuffixs="高"
            />
          </div>
        </div>
        <div class="content-item mb16">
          <div class="verticallyCenter mb16">
            <span class="fs14 mr16">颜色</span>
            <cx-color-picker
              class="custom-title-color flex1"
              :isThemeColor.sync="todayLegendBorderIsThemeColor"
              :colorArr.sync="todayLegendBorderColor"
            ></cx-color-picker>
          </div>
        </div>
      </div>
    </div>
    <cx-check-box :value.sync="showActivityLegend" class="mb16">显示活动</cx-check-box>
    <div v-show="showActivityLegend" class="legend-set-box mt16 mb16">
      <div class="content">
        <div class="content-item mb16 verticallyCenter">
          <span class="fs14 mr16">文字内容</span>
          <el-input class="flex1" v-model="activityLegendVal" placeholder="请输入内容"></el-input>
        </div>
        <div class="content-item mb16">
          <p class="font14 mb16 mt16">文字样式</p>
          <text-setting-update
            :fontColor.sync="activityLegendColor"
            :fontFamily.sync="activityLegendFontFamily"
            :fontSize.sync="activityLegendFontSize"
            :fontWeight.sync="activityLegendFontWeight"
          />
        </div>
        <p class="font14 mb16 mt16">图标样式</p>
        <div class="content-item mb16 legend-today-bg-set verticallyCenter">
          <span class="font14 mr12 label">样式</span>
          <el-tabs class="flex1" v-model="activeActivityLegendStyle" @tab-click="changeActivityLegendStyleFn">
            <el-tab-pane label="实心" name="solid"></el-tab-pane>
            <el-tab-pane label="空心" name="hollow"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="content-item mb16 verticallyCenter legend-shape-set">
          <span class="mr16">形状</span>
          <el-tabs class="flex1" v-model="activityLegendShapeType" @tab-click="changeActivityLegendShapeType">
            <el-tab-pane name="round"
              ><el-tooltip slot="label" class="item" effect="dark" content="圆形" placement="top-end" :open-delay="1000"
                ><i class="icon-portal-round"></i></el-tooltip
            ></el-tab-pane>
            <el-tab-pane name="rectangle"
              ><el-tooltip slot="label" class="item" effect="dark" content="矩形" placement="top-end" :open-delay="1000"
                ><i class="icon-portal-rectangle"></i></el-tooltip
            ></el-tab-pane>
            <el-tab-pane name="radius"
              ><el-tooltip
                slot="label"
                class="item"
                effect="dark"
                content="圆角矩形"
                placement="top-end"
                :open-delay="1000"
                ><i class="icon-portal-rounded-rectangle"></i></el-tooltip
            ></el-tab-pane>
          </el-tabs>
        </div>
        <slider-and-input
          class="mb16 width40"
          :value.sync="activityLegendBorderRadius"
          title="圆角"
          :sliderMax="99"
          :sliderMin="1"
          suffix="px"
        />
        <div class="verticallyCenter mb16">
          <div class="mr16" style="width: 40px">尺寸</div>
          <div class="flex1 verticallyCenter cx_style">
            <single-input
              class="mr12"
              :value.sync="activityLegendWidth"
              inputSuffixs="宽"
            />
            <single-input
              :value.sync="activityLegendHeight"
              inputSuffixs="高"
            />
          </div>
        </div>
        <div class="content-item mb16">
          <div class="verticallyCenter mb16">
            <span class="fs14 mr16">颜色</span>
            <cx-color-picker
              class="custom-title-color flex1"
              :isThemeColor.sync="activityLegendBorderIsThemeColor"
              :colorArr.sync="activityLegendBorderColor"
            ></cx-color-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="content-item verticallyCenter mb16">
      <slider-and-input
        class="width40"
        :value.sync="legendSpace"
        title="间距"
        :sliderMax="500"
        :sliderMin="1"
        suffix="px"
      />
    </div>
    <div class="content-item mb16">
      <cx-padding
        :paddingTypeFlag.sync="legendPaddingTypeFlag"
        :padding.sync="legendPadding"
        :paddingTop.sync="legendPaddingTop"
        :paddingRight.sync="legendPaddingRight"
        :paddingBottom.sync="legendPaddingBottom"
        :paddingLeft.sync="legendPaddingLeft"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  components: {},
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3"],
      activeTodayLegendStyle: "hollow",
      activeActivityLegendStyle: "hollow"
    }
  },
  computed: {
    legendPosition: {
      get() {
        return this.options.legendPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "legendPosition", false)
      }
    },
    showTodayLegend: {
      get() {
        return this.options.showTodayLegend
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showTodayLegend", false)
      }
    },
    todayLegendVal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "todayLegendVal", "todayLegendVal", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendVal", false)
      }
    },
    todayLegendColor: {
      get() {
        return this.options.todayLegendColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendColor", false)
      }
    },
    todayLegendFontFamily: {
      get() {
        return this.options.todayLegendFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendFontFamily", false)
      }
    },
    todayLegendFontSize: {
      get() {
        return this.options.todayLegendFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendFontSize", false)
      }
    },
    todayLegendFontWeight: {
      get() {
        return this.options.todayLegendFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendFontWeight", false)
      }
    },
    todayLegendBorderWidth: {
      get() {
        return this.options.todayLegendBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendBorderWidth", false)
      }
    },
    todayLegendBorderIsThemeColor: {
      get() {
        return this.options.todayLegendBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendBorderIsThemeColor", false)
      }
    },
    todayLegendBorderColor: {
      get() {
        return this.options.todayLegendBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendBorderColor", false)
      }
    },
    todayLegendBgColor: {
      get() {
        return this.options.todayLegendBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendBgColor", false)
      }
    },
    todayLegendBgType: {
      get() {
        return this.options.todayLegendBgType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendBgType", false)
      }
    },
    todayLegendShapeType: {
      get() {
        return this.options.todayLegendShapeType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendShapeType", false)
      }
    },
    todayLegendBorderRadius: {
      get() {
        return this.options.todayLegendBorderRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendBorderRadius", false)
      }
    },
    todayLegendWidth: {
      get() {
        return this.options.todayLegendWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendWidth", false)
      }
    },
    todayLegendHeight: {
      get() {
        return this.options.todayLegendHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "todayLegendHeight", false)
      }
    },

    showActivityLegend: {
      get() {
        return this.options.showActivityLegend
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showActivityLegend", false)
      }
    },
    activityLegendVal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activityLegendVal", "activityLegendVal", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendVal", false)
      }
    },
    activityLegendColor: {
      get() {
        return this.options.activityLegendColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendColor", false)
      }
    },
    activityLegendFontFamily: {
      get() {
        return this.options.activityLegendFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendFontFamily", false)
      }
    },
    activityLegendFontSize: {
      get() {
        return this.options.activityLegendFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendFontSize", false)
      }
    },
    activityLegendFontWeight: {
      get() {
        return this.options.activityLegendFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendFontWeight", false)
      }
    },
    activityLegendBorderWidth: {
      get() {
        return this.options.activityLegendBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendBorderWidth", false)
      }
    },
    activityLegendBorderIsThemeColor: {
      get() {
        return this.options.activityLegendBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendBorderIsThemeColor", false)
      }
    },
    activityLegendBorderColor: {
      get() {
        return this.options.activityLegendBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendBorderColor", false)
      }
    },
    activityLegendBgColor: {
      get() {
        return this.options.activityLegendBgColor
      },
      set(newVal) {
        console.log(newVal)
        this.$changeOptionsEV(newVal, "activityLegendBgColor", false)
      }
    },
    activityLegendBgType: {
      get() {
        return this.options.activityLegendBgType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendBgType", false)
      }
    },
    activityLegendShapeType: {
      get() {
        return this.options.activityLegendShapeType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendShapeType", false)
      }
    },
    activityLegendBorderRadius: {
      get() {
        return this.options.activityLegendBorderRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendBorderRadius", false)
      }
    },
    activityLegendWidth: {
      get() {
        return this.options.activityLegendWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendWidth", false)
      }
    },
    activityLegendHeight: {
      get() {
        return this.options.activityLegendHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activityLegendHeight", false)
      }
    },
    legendSpace: {
      get() {
        return this.options.legendSpace
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "legendSpace", false)
      }
    },
    // 标题边距
    legendPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (
          ((this.legendPaddingTop === this.legendPaddingRight) === this.legendPaddingLeft) ===
          this.legendPaddingBottom
        ) {
          defaultType = 2
        }
        return this.options.legendPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "legendPaddingTypeFlag", false)
      }
    },
    legendPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "legendPadding", "legendPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "legendPadding", false)
      }
    },
    legendPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "legendPaddingTop", "legendPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "legendPaddingTop", false)
      }
    },
    legendPaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "legendPaddingRight", "legendPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "legendPaddingRight", false)
      }
    },
    legendPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "legendPaddingBottom", "legendPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "legendPaddingBottom", false)
      }
    },
    legendPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "legendPaddingLeft", "legendPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "legendPaddingLeft", false)
      }
    }
  },
  methods: {
    changeLegendPosition() {},
    changeTodayLegendStyleFn() {
      if (this.activeTodayLegendStyle == "solid") {
        this.todayLegendBgType = 0
        this.todayLegendBgColor = this.todayLegendBorderColor.color
      } else {
        this.todayLegendBgType = 1
        this.todayLegendBgColor = "transparent"
      }
    },
    changeTodayLegendShapeType() {
      switch (this.todayLegendShapeType) {
        case "rectangle":
          this.todayLegendBorderRadius = 0
          break
        case "radius":
          this.todayLegendBorderRadius = 4
          break
        case "round":
          this.todayLegendBorderRadius = "50%"
      }
    },
    changeActivityLegendStyleFn() {
      if (this.activeActivityLegendStyle == "solid") {
        this.activityLegendBgType = 0
        this.activityLegendBgColor = this.activityLegendBorderColor.color
      } else {
        this.activityLegendBgType = 1
        this.activityLegendBgColor = "transparent"
      }
    },
    changeActivityLegendShapeType() {
      switch (this.activityLegendShapeType) {
        case "rectangle":
          this.activityLegendBorderRadius = 0
          break
        case "radius":
          this.activityLegendBorderRadius = 4
          break
        case "round":
          this.activityLegendBorderRadius = "50%"
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    }
  },
  mounted() {}
}
</script>

<style scoped>
.legend-today-bg-set {
  width: 100%;
}
.legend-today-bg-set .el-tabs {
  display: inline-block;
  width: calc(100% - 60px);
  vertical-align: middle;
}
::v-deep .legend-position-set .el-tabs .el-tabs__content,
::v-deep .legend-today-bg-set .el-tabs .el-tabs__content,
::v-deep .legend-shape-set .el-tabs .el-tabs__content {
  display: none;
}
::v-deep .legend-shape-set .el-tabs .el-tabs__item {
  font-size: 16px;
}
.font-arrangement-btn1 .btn-active {
  width: calc((100% - 6px) / 2);
}
.font-arrangement-btn2 .btn-active {
  width: calc((100% - 6px) / 4);
}
.font-arrangement-btn1.height32 span {
  height: 26px;
  line-height: 26px;
  font-size: 13px;
}
.font-arrangement-btn.height32 span i {
  line-height: 26px;
}
.height32 {
  height: 32px;
}
.legend-set-box {
  padding: 12px;
  background: #fbfcfd;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
}
</style>
